
import React from 'react'

import Comment from './Comment'

import './CommentsList.scss'

interface Props {
  items: any[]
}

const CommentsList = ({ items }: Props) => {

  return (
    <div className='comments-list'>
      {items.map((item: any, i: number) => (
        <Comment key={i} item={item} />
      ))}
    </div>
  )
}

export default CommentsList
